import { render, staticRenderFns } from "./CollegeUserProfile.vue?vue&type=template&id=5ac7c35a"
import script from "./CollegeUserProfile.vue?vue&type=script&lang=js"
export * from "./CollegeUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports